<template>
  <div class="user-add-container">
    <div class="back">
      <span @click="$router.go(-1)"
        ><i class="iconfont icon-back"></i>返回</span
      >
    </div>
    <div class="content">
      <div class="title">基本信息</div>
      <div class="box">
        <div class="avatar">
          <div class="img">
            <el-upload
              class="upload-demo"
              :action="URL + '/data/upload'"
              :show-file-list="false"
              :headers="{ Authorization: 'bearer' + token }"
              :on-success="handleAvatarSuccess"
              :limit="1"
            >
              <img v-if="data.photo" :src="data.photo" alt="" />
              <img v-else src="@/assets/images/avatar-defult.jpg" alt="" />
            </el-upload>
          </div>
        </div>
        <div class="form">
          <el-form ref="form" :rules="rules" :model="data" label-width="160px">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="类型" prop="role_id">
                  <el-select
                    v-model="data.role_id"
                    :disabled="editDetail"
                    placeholder="请选择"
                    style="width: 100%"
                    @change="roleChange"
                  >
                    <el-option
                      v-for="item in options.roleOptions"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                      :disabled="item.disabled"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="真实姓名" prop="name">
                  <el-input
                    v-model="data.name"
                    :disabled="editDetail"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="用户名" prop="username">
                  <el-input
                    v-model="data.username"
                    :disabled="editDetail"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </el-col>
              <div v-if="!id">
                <el-col :span="12">
                  <el-form-item label="密码" prop="password">
                    <el-input
                      v-model="data.password"
                      :disabled="editDetail"
                      show-password
                      placeholder="请输入"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </div>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="公司名称" prop="belong_company">
                  <!-- <el-select v-model="belong_company"  placeholder="请选择" style="width:100%; display: inline-block;">
                        <el-option
                          v-for="item in companyOptions"
                          :key="item.company_id"
                          :label="item.company_name"
                          :value="item.company_id">
                        </el-option>
                    </el-select> -->
                  <template v-if="true">
                    <el-select
                      v-model="data.belong_company"
                      :disabled="editDetail"
                      placeholder="请选择"
                      style="width: 100%"
                    >
                      <el-option
                        v-for="item in options.companyOptions"
                        :key="item.company_id"
                        :label="item.company_name"
                        :value="item.company_id"
                      >
                      </el-option>
                    </el-select>
                  </template>
                  <template v-else>
                    <el-select
                      v-model="data.belong_company"
                      disabled
                      placeholder="请选择"
                      style="width: 100%"
                    >
                      <el-option
                        v-for="item in options.companyOptions"
                        :key="item.company_id"
                        :label="item.company_name"
                        :value="item.company_id"
                      >
                      </el-option>
                    </el-select>
                  </template>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="员工编号">
                  <el-input
                    v-model="data.employee_num"
                    :disabled="editDetail"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="公司地址">
                  <el-input
                    v-model="data.company_address"
                    :disabled="editDetail"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="联系电话" prop="phone">
                  <el-input
                    v-model="data.phone"
                    :disabled="editDetail"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="部门名称">
                  <el-input
                    v-model="data.department"
                    :disabled="editDetail"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="座机">
                  <el-input
                    v-model="data.landline"
                    :disabled="editDetail"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="岗位名称">
                  <el-input
                    v-model="data.job"
                    :disabled="editDetail"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="邮箱">
                  <el-input
                    v-model="data.email"
                    :disabled="editDetail"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <!-- <el-row :gutter="20">
              <el-form-item label="权限">
                <el-checkbox-group v-model="data.role">
                  <el-checkbox label="全部系统权限"></el-checkbox><br/>
                  <el-checkbox label="查看所属车辆信息"></el-checkbox><br/>
                  <el-checkbox label="维护车辆基础信息"></el-checkbox>
                </el-checkbox-group>
                <el-checkbox v-model="data.role1">全部系统权限</el-checkbox><br/>
                <el-checkbox v-model="data.role2">查看所属车辆信息</el-checkbox><br/>
                <el-checkbox v-model="data.role3">维护车辆基础信息</el-checkbox>
              </el-form-item>
            </el-row> -->
          </el-form>
          <div class="btns">
            <el-button
              type="primary"
              v-if="editButton"
              @click="submitForm('form')"
              >保存信息</el-button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { GetRoleList, SetUserDeatil, GetUserDeatil } from '@/api/user'
import { isPhone } from '@/utils/validate'
import { getToken } from '@/utils/auth'
import { selectCompanyData } from '@/api/company'
export default {
  data () {
    return {
      id: null,
      editDetail: false,
      editButton: true,
      token: getToken(),
      data: {
        photo: '',
        belong_company: null,
        role_id: null
      },
      rules: {
        role_id: [
          { required: true, message: '请输入', trigger: 'change' }
        ],
        name: [
          { required: true, message: '请输入', trigger: 'change' }
        ],
        company: [
          { required: true, message: '请选择', trigger: 'change' }
        ],
        number: [
          { required: true, message: '请选择', trigger: 'change' }
        ],
        address: [
          { required: true, message: '请选择', trigger: 'change' }
        ],
        phone: [
          { required: true, message: '请输入', trigger: 'change' },
          { pattern: isPhone, message: '请输入正确的手机号!' },
        ],
        dept: [
          { required: true, message: '请输入', trigger: 'change' }
        ],
        landline: [
          { required: true, message: '请输入', trigger: 'change' }
        ],
        post: [
          { required: true, message: '请输入', trigger: 'change' }
        ],
        email: [
          { required: true, message: '请输入', trigger: 'change' }
        ],
        username: [
          { required: true, message: '请输入', trigger: 'change' }
        ],
        password: [
          { required: true, message: '请输入', trigger: 'change' }
        ],
        belong_company: [
          { required: true, message: '请选择所属公司', trigger: 'bur' }
        ]
      },
      options: {
        roleOptions: [],
        companyOptions: []
      },
      companyData: [],
      userRoleData: [],
      URL: process.env.VUE_APP_BASE_API
    }
  },
  created () {
    this.id = this.$route.query.id
    let detailRoleId = this.$route.query.roleId
    if ((detailRoleId == 5 || detailRoleId == 2)) {
      this.editButton = false
    }
    this.getRoleData()
    this.initCompanyData()
  },
  methods: {
    getRoleData () {
      GetRoleList()
        .then(res => {
          if (res.code === 0) {
            this.userRoleData = res.data
            this.queryRoleOptions()
            this.getData()
          }
        })
    },
    handleAvatarSuccess (res) {
      if (res.code === 0) {
        this.data.photo = res.data.src
      }
    },
    getData () {
      const params = { id: this.id }
      GetUserDeatil(params)
        .then(res => {
          res.data.role_id = Number(res.data.role_id)
          res.data.belong_company = Number(res.data.belong_company)
          this.initSelectData(res.data.role_id, res.data)
        })
    },
    // 提交表单
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // alert('submit!')
          if (this.id) {
            this.data.id = this.id
          }
          SetUserDeatil(this.data).then(res => {
            if (res.code == 0) {
              this.$message.success('保存成功!')
              this.$router.back(-1)
            } else if (res.code == 1002) {
              this.$message.error('保存失败,用户名重复!')
            } else {
              this.$message.error('保存失败,用户信息错误!')
            }
          })
        } else {
          //console.log('error submit!!')
          return false
        }
      })
    },
    //根据角色获取页面角色下拉数据  --角色类型数据options
    queryRoleOptions () {
      this.userRoleData.forEach(el => {
        if (el.level == 1 || el.level == 2) {
          el.disabled = false
        } else {
          el.disabled = true
        }
        this.options.roleOptions.push(el)
      })
    },
    //获取公司树数据
    initCompanyData () {
      selectCompanyData().then(res => {
        this.companyData = res.data
      })
    },
    //类型选中事件   -- 所属公司数据 companyData
    roleChange () {
      let roleId = this.data.role_id
      this.clearCompanySelect()
      this.initSelectChange(roleId)
      if (roleId == 5) {
        this.rules.belong_company = [{ required: false, message: '请选择所属公司', trigger: 'bur' }]
      } else {
        //this.edit =true
        this.rules.belong_company = [{ required: true, message: '请选择所属公司', trigger: 'bur' }]
      }
    },
    //点击类型是初始化公司数据
    initSelectChange (roleId) {
      this.initCompanyOptions(roleId)
    },
    //页面初数据初始化时
    initSelectData (roleId, returnData) {
      this.initCompanyOptions(roleId)
      this.data = returnData
    },
    initCompanyOptions (roleId) {
      if (roleId === 1 || roleId === 3) {
        this.companyData.forEach(el => {
          if (el.company_code == 0) {
            this.options.companyOptions.push(el)
          }
        })
      } else if (roleId === 6) {
        this.companyData.forEach(el => {
          if (el.company_code == 1) {
            this.options.companyOptions.push(el)
          }
        })
      } else if (roleId === 7) {
        this.companyData.forEach(el => {
          if (el.company_code == 2) {
            this.options.companyOptions.push(el)
          }
        })
      } else if (roleId === 2) {
        this.companyData.forEach(el => {
          if (el.company_code == 3) {
            this.options.companyOptions.push(el)
          }
        })
      } else if (roleId === 5) {
        this.companyData.forEach(el => {
          if (el.company_code == 4) {
            this.options.companyOptions.push(el)
          }
        })
        this.rules.belong_company = [{ required: false, message: '请选择所属公司', trigger: 'bur' }]
      }
    },
    //类型下拉时，清空所属公司
    clearCompanySelect () {
      this.data.belong_company = null
      this.options.companyOptions = []
    }
  }
}
</script>

<style lang="less" scoped>
.user-add-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 20px 20px;
  .back {
    color: #42a3df;
    font-size: 20px;
    font-weight: bold;
    padding-bottom: 10px;
    span {
      cursor: pointer;
    }
    .iconfont {
      margin-right: 10px;
    }
  }
  .content {
    flex: 1;
    min-height: 0;
    width: 100%;
    padding: 20px 20px;
    background: #fff;
    box-shadow: 0 0 6px 1px #acacac;
    overflow-y: auto;
    .title {
      font-size: 18px;
      line-height: 40px;
      font-weight: bold;
      color: #1f7eb8;
    }
    .box {
      display: flex;
      padding-top: 30px;
      .btns {
        padding: 30px 160px 60px;
      }
      .avatar {
        .img {
          padding: 30px 10px;
          border: 1px solid #bbb;
          img {
            width: 156px;
            height: 159px;
            display: block;
          }
        }
      }
      .form {
        flex: 1;
        min-width: 0;
        max-width: 1100px;
      }
    }
  }
  #map-container {
    width: 100%;
    height: 400px;
    box-shadow: 0 0 10px 1px #acacac;
  }
}
</style>
<style lang="less">
.equipment-add-container {
  .el-form-item__label {
    color: #1a2550;
    padding: 0 30px 0 0;
  }
  .el-select,
  .el-input {
    width: 100%;
  }
}
</style>
